import React, { useState } from 'react';
import axios from '../api/axiosConfig';
import './Modal.css';

const CargarCUPLModal = ({ isOpen, onClose, tramite, onSuccess }) => {
  const [cuplNumber, setCuplNumber] = useState('');
  const [pdfFile, setPdfFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen || !tramite) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pdfFile) {
      setError('El archivo PDF del CUPL es obligatorio.');
      return;
    }

    setLoading(true);
    setError('');

    const formData = new FormData();
    formData.append('cupl_number', cuplNumber); // puede ir vacío, el backend lo extrae del PDF
    formData.append('cupl_pdf', pdfFile);
    formData.append('tramite_id', tramite.id);

    try {
      const response = await axios.post(`/api/tramites/${tramite.id}/cargar-cupl`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(response.data.message || 'CUPL cargado exitosamente');
      onSuccess();
      onClose();
      setCuplNumber('');
      setPdfFile(null);

    } catch (err) {
      console.error('Error al cargar CUPL:', err);
      alert(err.response?.data?.message || 'Error al cargar el CUPL');
      setError(err.response?.data?.message || 'Error al cargar el CUPL');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h3>📄 Cargar CUPL - Trámite #{tramite.id}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form" style={{ padding: '20px 0' }}>
          {error && <div className="error-banner" style={{ marginBottom: '15px' }}>{error}</div>}
          
          <div className="info-card" style={{ background: '#f8fafc', padding: '15px', borderRadius: '10px', marginBottom: '20px', border: '1px solid #e2e8f0' }}>
            <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}><strong>Propietario:</strong> {tramite.datos_adicionales?.propietario}</p>
            <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}><strong>Placa:</strong> <span className="plate-badge-sm">{tramite.datos_adicionales?.placa_referencia || 'N/A'}</span></p>
            <p style={{ margin: '0', fontSize: '14px' }}><strong>Tránsito:</strong> <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '2px 10px', borderRadius: '6px', fontWeight: '600', fontSize: '13px' }}>{tramite.transito_name || 'N/A'}</span></p>
          </div>

          <div className="form-group">
            <label>Número de CUPL: <span style={{ color: '#94a3b8', fontWeight: '400', fontSize: '12px' }}>(Opcional)</span></label>
            <input 
              type="text" 
              value={cuplNumber} 
              onChange={(e) => setCuplNumber(e.target.value)} 
              placeholder="Dejar vacío para extraer del PDF automáticamente"
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
            />
            <small style={{ color: '#2563eb', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '5px', fontSize: '12px' }}>
              💡 Si no ingresa el número, se extraerá automáticamente del documento PDF.
            </small>
          </div>

          <div className="form-group" style={{ marginTop: '15px' }}>
            <label>Archivo PDF del CUPL: <span style={{ color: '#ef4444' }}>*</span></label>
            <input 
              type="file" 
              accept=".pdf" 
              onChange={(e) => setPdfFile(e.target.files[0])} 
              required
              style={{ padding: '10px', background: '#f1f5f9', borderRadius: '8px', border: '1px dashed #cbd5e1', width: '100%' }}
            />
            <small style={{ color: '#64748b', display: 'block', marginTop: '5px' }}>Solo se permiten archivos PDF. Se extraerán automáticamente: número CUPL, fecha de vencimiento y monto total.</small>
          </div>

          <div className="modal-actions" style={{ marginTop: '30px' }}>
            <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? '⏳ Procesando PDF...' : '🚀 Enviar CUPL'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CargarCUPLModal;
